export const discountColors: Record<string, string> = {
  green: 'from-[#B6E828] to-[#92CF2F]',
  red: 'from-[#EB5757] to-[#EC3E3E]',
  yellow: 'from-[#FFD452] to-[#FF9900]',
  orange: 'from-[#FF9040] to-[#FF7A00]',
};
